import React from 'react';
import update from 'react-addons-update';
import SMFormHelper from 'components/helpers/SMFormHelper';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import 'react-mdl/extra/material.js';
import {Textfield, Checkbox} from 'react-mdl';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMOSignUpFormView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      resource: this.props.resource,
      errors: this.props.errors,
      gender: "",
      accept: false,
    };
  }

  componentDidMount() {
    SMTrackHelper.criteoBasket("", "createOwner", 2000, 1);

    let owner = {};
    if (this.state.resource.birth_date) {
      const birthDate = new Date(this.state.resource.birth_date);
      owner["birth_year"] = birthDate.getFullYear();
      owner["birth_month"] = birthDate.getMonth() + 1;
      owner["birth_day"] = birthDate.getDate();
    }
    if (this.state.resource.corp_found_date) {
      const corpFoundDate = new Date(this.state.resource.corp_found_date);
      owner["corp_found_year"] = corpFoundDate.getFullYear();
      owner["corp_found_month"] = corpFoundDate.getMonth() + 1;
      owner["corp_found_day"] = corpFoundDate.getDate();
    }

    this.setState({
      accept: (this.state.resource.terms_accepted_ip) ? true : false,
      resource: update(this.state.resource, { $merge: owner })
    });
  }

  textFieldDidChange(e) {
    let payload = {};
    payload[e.currentTarget.name] = e.currentTarget.value;
    this.setState({
      resource: update(this.state.resource, { $merge: payload })
    });
  }

  selectBoxDidChangeValue(e) {
    let payload = {};
    payload[e.currentTarget.name] = e.currentTarget.value;
    this.setState({
      resource: update(this.state.resource, { $merge: payload })
    });
  }

  checkBoxDidChangeValue(e) {
      if (e.currentTarget.name == 'accept') {
        this.setState({
          accept: e.currentTarget.checked
        });
      } else {
        let payload = {};
        payload[e.currentTarget.name] = e.currentTarget.checked;
        this.setState({
          resource: update(this.state.resource, {$merge: payload })
        });
      }
  }

  renderCorpInputForm() {
    if (!this.state.resource.is_corp || this.state.resource.is_corp == 'false') return null;

    return(
      <div>
        <div className="col-sm-12">
          <p className="material-form__title">法人名</p>
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              name="corp_name"
              value={this.state.resource.corp_name}
              label={'株式会社 スペースマーケット'}
            />
            <SMFormValidationMessage name="corp_name" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'corp_name', this.props.errors)} />
          </div>
        </div>
        <div className="col-sm-12">
          <p className="material-form__title">法人名（カナ）</p>
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              name="corp_name_kana"
              value={this.state.resource.corp_name_kana}
              label={'カブシキカイシャ スペースマーケット'}
            />
            <SMFormValidationMessage name="corp_name_kana" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'corp_name_kana', this.props.errors)} />
          </div>
        </div>

      </div>
    );
  }

  render() {
    let btnClassName = this.state.accept ? 'button-blue' : 'button-disabled';
    btnClassName += " mt20 pt15 pb15 w300 sm-w100";
    const genders = [{ value: "", label: "選択してください" },{ value: 1, label: "男性" },{ value: 2, label: "女性" }];

    return (
        <div className="site-main">
          <div className="page__even lp-page__padding">
            <div className="page__col1">
              <div className="signup-head">
                <h1 className="page-title">ホスト新規登録</h1>
                <ul className="signup-step signup-step2 mb20">
                  <li className="signup-step__status1 is-current">新規登録</li>
                  <li className="signup-step__status3">登録完了</li>
                </ul>
              </div>

              <form ref="form" action={Routes.owners_path()} method="post" encType="multipart/form-data" acceptCharset="UTF-8">
                <input type="hidden" name='authenticity_token' value={this.props.authenticity_token} />
                <div className="signup-box">
                  <div className="row">
                    <div className="col-xs-12">
                        <div className="signup-box__wrapper-form">
                          <div className="row signup-box__md-top">
                            <div className="col-sm-12">
                              <p className="material-form__title">担当者氏名</p>
                            </div>
                            <div className="col-sm-6">
                              <Textfield
                                onChange={(e) => this.textFieldDidChange(e)}
                                name="family_name"
                                value={this.state.resource.family_name}
                                label={'スペスマ'}
                                className="w100pa"
                              />
                            </div>
                            <div className="col-sm-6">
                              <Textfield
                                onChange={(e) => this.textFieldDidChange(e)}
                                name="given_name"
                                value={this.state.resource.given_name}
                                label={'太郎'}
                                className="w100pa"
                              />
                            </div>
                            <SMFormValidationMessage name="family_name" options={{ className: "signup-box__required col-sm-12" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'family_name', this.props.errors)} />
                            <SMFormValidationMessage name="given_name" options={{ className: "signup-box__required col-sm-12" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'given_name', this.props.errors)} />
                            <div className="col-sm-12">
                              <p className="material-form__title">担当者氏名（カナ）</p>
                            </div>
                            <div className="col-sm-6">
                              <Textfield
                                onChange={(e) => this.textFieldDidChange(e)}
                                name="family_name_kana"
                                value={this.state.resource.family_name_kana}
                                label={'スペスマ'}
                                className="w100pa"
                              />
                            </div>
                              <div className="col-sm-6">
                                <Textfield
                                  onChange={(e) => this.textFieldDidChange(e)}
                                  name="given_name_kana"
                                  value={this.state.resource.given_name_kana}
                                  label={'タロウ'}
                                  className="w100pa"
                                />
                              </div>
                              <SMFormValidationMessage name="family_name_kana" options={{ className: "signup-box__required col-sm-12" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'family_name_kana', this.props.errors)} />
                              <SMFormValidationMessage name="given_name_kana" options={{ className: "signup-box__required col-sm-12" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'given_name_kana', this.props.errors)} />
                            <div className="col-sm-12">
                              <p className="material-form__title">生年月日<span className="material-form__required">個人の場合必須</span></p>
                            </div>
                            <div className="col-xs-4">
                              <div className="mdl-textfield w100pa">
                                <span className="service-select material-select">
                                  <SMFormSelectBox
                                    name="birth_year"
                                    selectedValue={this.state.resource.birth_year}
                                    items={SMFormHelper.birthYearOptionsForSelect()}
                                    options={{className:"w100pa"}}
                                    delegate={this}
                                  />
                                </span>
                              </div>
                            </div>
                            <div className="col-xs-1">
                              <p className="mdl-textfield w100pa material-form__unit">/</p>
                            </div>
                            <div className="col-xs-3">
                              <div className="mdl-textfield w100pa">
                                <span className="service-select material-select">
                                  <SMFormSelectBox
                                    name="birth_month"
                                    items={SMFormHelper.monthOptionsForSelect()}
                                    selectedValue={this.state.resource.birth_month}
                                    options={{className:"w100pa"}}
                                    delegate={this}
                                  />
                                </span>
                              </div>
                            </div>
                            <div className="col-xs-1">
                              <p className="mdl-textfield w100pa material-form__unit">/</p>
                            </div>
                            <div className="col-xs-3">
                              <div className="mdl-textfield w100pa">
                                <span className="service-select material-select">
                                  <SMFormSelectBox
                                    name="birth_day"
                                    items={SMFormHelper.dayOptionsForSelect()}
                                    selectedValue={this.state.resource.birth_day}
                                    options={{className:"w100pa"}}
                                    delegate={this}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row signup-box__md-top">
                            <div className="col-sm-6">
                              <p className="material-form__title">性別</p>
                              <div className="mdl-textfield w100pa">
                                <span className="service-select material-select">
                                  <SMFormSelectBox
                                    name="gender"
                                    items={genders}
                                    selectedValue={this.state.resource.gender}
                                    options={{className:"w100pa"}}
                                    delegate={this}
                                  />
                                </span>
                              </div>
                              <SMFormValidationMessage name="gender" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'gender', this.props.errors)} />
                            </div>
                            <div className="col-sm-12">
                              <p className="material-form__title pb20">法人の場合はチェックを入れてください</p>
                              <p className="material-form__unit">
                                  <Checkbox
                                    id="checkbox-1"
                                    label="法人"
                                    name="is_corp"
                                    value="true"
                                    checked={(this.state.resource.is_corp == null || this.state.resource.is_corp == "false" || this.state.resource.is_corp == false) ? false : true}
                                    onChange={this.checkBoxDidChangeValue.bind(this)}
                                  />
                              </p>
                            </div>

                            {this.renderCorpInputForm()}

                            <div className="col-sm-12">
                              <p className="material-form__title">電話番号</p>
                              <Textfield
                                onChange={(e) => this.textFieldDidChange(e)}
                                name="tel"
                                value={this.state.resource.tel}
                                label={'0363045618'}
                                className="w100pa"
                              />
                              <SMFormValidationMessage name="tel" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'tel', this.props.errors)} />
                            </div>
                            <div className="col-sm-12">
                              <p className="material-form__title">連絡先メールアドレス</p>
                              <Textfield
                                onChange={(e) => this.textFieldDidChange(e)}
                                name="email"
                                value={this.state.resource.email}
                                label={'sample@spacemarket.co.jp'}
                                className="w100pa"
                              />
                              <SMFormValidationMessage name="email" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'email', this.props.errors)} />
                            </div>
                            <div className="col-sm-12">
                              <div className="signup-box__wrapper-form-profile clearfix">
                                <p className="material-form__title">ホスト名</p>
                                <p className="material-form__description">URLやゲストのクレジットカード明細におけるアルファベット表記に使用されます。3文字以上20文字以下、大小英数字、_（アンダーバー）、-（ハイフン）、数字のみではない文字列が使用可能です。</p>
                                <Textfield
                                  onChange={(e) => this.textFieldDidChange(e)}
                                  name="username"
                                  value={this.state.resource.username}
                                  className="w100pa"
                                  label=""
                                  placeholder="spacemarket"
                                />
                              <SMFormValidationMessage name="username" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'username', this.props.errors)} />
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-7">
                              <p className="signup-box__wrapper-form-notes">ご登録前に<a href={Routes.terms_of_partner_for_new_owners_dashboard_about_index_path()} target="_blank" className="a__underline">ホスト規約</a>をお読みください。</p>
                              <Checkbox
                                id="checkbox-2"
                                label="ホスト規約に同意する"
                                name="accept"
                                checked={this.state.accept}
                                value={this.state.accept}
                                onChange={this.checkBoxDidChangeValue.bind(this)}
                              />
                              <SMFormValidationMessage name="term_of_service" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'term_of_service', this.props.errors)} />
                            </div>
                            <div className="col-sm-12 ta-c">
                              <input type="submit" name="commit" value="登録する" className={btnClassName} disabled={!this.state.accept} />
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
            </form>
            </div>
          </div>
        </div>
    );
  }
}
export default SMOSignUpFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/sessions/SMOSignUpFormView.jsx